import Header from "components/Header"
import React from "react"
import AuctionDetails from "views/Auctions/AuctionDetails"
import {connect} from "react-redux"
import {GlobalState} from "../state"
import {Auction, User} from "../domain-models"
import {classNames} from "../utils/class-names"
import {luxuryThemeClass} from "../utils/luxury"
import Notification from "react-notify-toast"

type AppProps = {
  auction: Auction | null
  user: User | null
  children: any
}

type AppState = {}

class App extends React.Component<AppProps, AppState> {
  render() {
    return (
      <div className={classNames(
        "flex flex-col bg-gray-200 w-full h-full overflow-hidden scrolling-smooth absolute",
        luxuryThemeClass(this.props.user)
      )}>
        <Notification options={{width: '100%'} as any}/>

        {
          this.props.auction ?
            <AuctionDetails auction={this.props.auction}/>
            : null
        }

        <Header/>
        <div className="overflow-hidden w-full h-full">
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  auction: state.auctions.auction,
  user: state.user
}))(App)